import { contactsApi } from '../../api/contacts-api';
import { contactName, type Contact, type ContactResolution } from '../../domain/contact';

export interface SiteReceiver {
  name: string;
  phone?: string | undefined;
}

/**
 * Who takes goods at a site (tidaltech/koi#8359), as leatherback picks it
 * for a shipment: the Receiving contact, else the Operations contact, at
 * the nearest level with one, primary first and preferring one with a phone.
 */
export function siteReceiver(resolutions: readonly ContactResolution[]): SiteReceiver | undefined {
  for (const purpose of ['RECEIVING', 'OPERATIONS'] as const) {
    const contacts: Contact[] =
      resolutions.find((resolution) => resolution.purpose === purpose)?.contacts ?? [];
    const chosen = contacts.find((contact) => contact.phone) ?? contacts[0];
    if (chosen) return { name: contactName(chosen), phone: chosen.phone };
  }
  return undefined;
}

/** The site's receiver, or undefined when it has none or contacts can't be read. */
export async function fetchSiteReceiver(siteId: string): Promise<SiteReceiver | undefined> {
  try {
    return siteReceiver(await contactsApi.resolveContacts(siteId));
  } catch {
    return undefined;
  }
}
